import getLegsWithoutRepeatingDisruptions from "../disruptions/getLegsWithoutRepeatingDisruptions";
import isTransitLeg from "../legs/isTransitLeg";
const mapTSILegsToTSIJourney = (legs, tsiLegs = []) => {
  const tsiLegsWithoutRepeatingDisruptions = getLegsWithoutRepeatingDisruptions(tsiLegs);
  let ndx = 0;
  const legIdToTSILeg = legs == null ? void 0 : legs.reduce((acc, leg) => isTransitLeg(leg) ? {
    ...acc,
    [leg.id]: tsiLegsWithoutRepeatingDisruptions[ndx++]
  } : acc, {});
  return { legIdToTSILeg };
};
var mapTSILegsToTSIJourney_default = mapTSILegsToTSIJourney;
export {
  mapTSILegsToTSIJourney_default as default
};
